


























































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import PartnerSearch from "../../partner/views/PartnerSearch.vue";
import store, { BankStatementStore } from "../services/BankStatementStore";
import pStore, { PartnerStore } from "../../partner/services/PartnerStore";
import BankDocument from "../models/BankDocument";
import Partner from "../../partner/models/Partner";
import DateInput from "@/components/DateInput.vue";
import SpecialDimensionButton from "@/components/SpecialDimensionButton.vue";
import dayjs from "dayjs";
import auth from "@/services/auth";
import MoneyInput from "@/components/MoneyInput.vue";
import SortingView from "./SortingView.vue";
import bIStore, {
  BankInViewStore,
} from "@/modules/bankInView/services/BankInViewStore";
import bOStore, {
  BankOutViewStore,
} from "@/modules/bankOutView/services/BankOutViewStore";
import BankOutView from "@/modules/bankOutView/models/BankOutView";
import BankInView from "@/modules/bankInView/models/BankInView";
import configuration, { AppConfiguration } from "@/models/Configuration";
import BankInViewApiSearchPage from "@/modules/bankExtract/components/BankInViewApiSearchPage.vue";
import BankOutViewApiSearchPage from "@/modules/bankExtract/components/BankOutViewApiSearchPage.vue";
import BankInOutViewApiSearchPage from "@/modules/bankExtract/components/BankInOutViewApiSearchPage.vue";
import BankInOutView from "@/modules/bankExtract/models/BankInOutView";
import { FilteringModel } from "@/services/filtering";
import eventBus from "@/services/eventBus";
import http, { handleApiResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import BankStatementApi from "../services/BankStatementApi";
import AccountType from "@/modules/accountType/models/AccountType";
import ConfirmationBox from "@/components/ConfirmationBox.vue";
import BankInOverViewApiSearchPage from "@/modules/bankExtract/components/BankInOverViewApiSearchPage.vue";
import BankOutOverViewApiSearchPage from "@/modules/bankExtract/components/BankOutOverViewApiSearchPage.vue";
import ReportSelection from "../models/ReportSelection";
import EmailSelection from "../models/EmailSelection";
import PayResult from "../models/PayResult";
import EmailPicker from "./EmailPicker.vue";
import GenoEInvoiceDocuments from "@/modules/kanri/components/GenoEInvoiceDocuments.vue";
import CarsApiSearch from "@/modules/bankExtract/components/CarsApiSearch.vue";

export interface BankOutSelect {
  selectedItems: BankOutView[];
  partnerID: number;
  isOverrideAmount: boolean;
}

export interface BankInSelect {
  selectedItems: BankInView[];
  partnerID: number;
  isOverrideAmount: boolean;
}

export interface BankInOutSelect {
  selectedItems: BankInOutView[];
  partnerID: number;
  isOverrideAmount: boolean;
}

interface Data {
  store: BankStatementStore;
  pStore: PartnerStore;
  bIStore: BankInViewStore;
  bOStore: BankOutViewStore;

  sortVisible: boolean;
  allInvoiceSelector: boolean;

  configuration: AppConfiguration;

  filter: FilteringModel;

  loading: boolean;
  isOverpaymentWarning: boolean;
  isOverPayment: boolean;
  originalAccountType: number;
  payInProgress: boolean;
  wrongInProgress: boolean;
  saveInProgress: boolean;
  payementGenIsProgress: boolean;
  currAmount: number;
  amount: number;
  isAmountChangeVisible: boolean;
  bankOutSelect: BankOutSelect|undefined;
  bankInSelect: BankInSelect|undefined;
  bankInOutSelect: BankInOutSelect|undefined;
  lateEdit: boolean;
  isReportSelect: boolean;
  reportSelection: Array<ReportSelection>|undefined;
  emailSelection: boolean;
  selectedEmails: Array<EmailSelection>|undefined;
  isPostPayEInvoice: boolean;
  carSelect: boolean;
}

interface Methods {
  isPaymentSumConfirmNeeded(selectedBankSum: number, hufSum: number, itemCrediting?: boolean): boolean;
  generateBankOutsSelected(items: BankOutSelect): void;
  generateBankInsSelected(items: BankInSelect): void;
  generateBankInOutsSelected(items: BankInOutSelect): void;
  cancel(): void;
  save(): void;
  partnerSelected(partner: Partner): void;
  sort(): void;
  cancelSort(): void;
  setExchangeRate(): void;
  onInvoiceCurrencyChange(value: string): void;
  resetCurrencyAmounts(): void;
  setBackToDefault(): void;
  bankDocumentAmountChanged(amount: number): void;
  bankDocumentCurrAmountChanged(amount: number): void;
  accountSubTypeChanged(value: number): void;
  accountTypeChanged(value: number): void;
  setPaid(): void;
  setWrong(): void;
  getNewItemCurrencyRate(force: boolean): Promise<void>;
  setAccountSubType(): void;
  paid(): void;
  generateOverPayment(): void;
  saveOnlyPaid(): void;
  preparePostPayEInvoice(): Promise<void>;
  payBankDocument(eInvoiceSelections?: { noto: number; isEInvoice: boolean }[]): Promise<PayResult | undefined>;
  onEmailSelectionConfirm(): void;
  confirmPostPayEInvoice(): Promise<void>;
  cancelEmailSelection(): void;
  generateBankInOverSelected(items: any): void;
  generateBankOutOverSelected(items: any): void;
  setAmounts(): void;
  edit(): void;
  carSelected(item: any): void;
}

interface Computed {
    isDisabled: boolean;
    isSortingVisible: boolean;
    bankDocument: BankDocument;
    crediting: boolean;
    defaultCurrency: any;
    currencyRate: number;
    accountType: number;
    isInvoiceSelect: boolean;
    isOverSelect: boolean;
    isReopen: boolean;
    accountTypes: any;
    isReverseSelection: boolean;
    subtypeItems: any;
    isPayment: boolean;
    isDevBank: boolean;
    isEditable: boolean;
    carsVisible: boolean;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    PartnerSearch,
    DateInput,
    MoneyInput,
    SortingView,
    BankInViewApiSearchPage,
    BankOutViewApiSearchPage,
    BankInOutViewApiSearchPage,
    ConfirmationBox,
    BankInOverViewApiSearchPage,
    BankOutOverViewApiSearchPage,
    EmailPicker,
    GenoEInvoiceDocuments,
    CarsApiSearch,
    SpecialDimensionButton
  },

  data() {
    return {
      store,
      pStore,
      bIStore,
      bOStore,

      sortVisible: false,
      allInvoiceSelector: false,

      configuration,
      filter: new FilteringModel(),

      loading: false,
      isOverpaymentWarning: false,
      isOverPayment: false,
      originalAccountType: 1,
      payInProgress: false,
      wrongInProgress: false,
      saveInProgress: false,
      payementGenIsProgress: false,
      currAmount: 0,
      amount: 0,
      isAmountChangeVisible: false,
      bankOutSelect: undefined,
      bankInSelect: undefined,
      bankInOutSelect: undefined,
      lateEdit: false,
      isReportSelect: false,
      reportSelection: undefined,
      emailSelection: false,
      selectedEmails: undefined,
      isPostPayEInvoice: false,
      carSelect: false,
    };
  },

  async beforeMount() {
    if (this.store.bankDocument.bankStatementItem.id <= 1) {
      this.store.bankDocument.user = auth.userName;
      this.store.bankDocument.bankStatementItem.user = auth.userID;
      this.store.bankDocument.bankStatementItem.currency = this.defaultCurrency.value;
      this.store.bankDocument.bankStatementItem.invCurrency = this.store.bankStatement.currency;
      this.store.bankDocument.bankStatementItem.extNo = Number.parseInt(this.$route.params.id);
      this.store.bankDocument.bankAccountCurrency = this.store.bankStatement.currency;

      // Új tételnél – ha a rendszerparaméter fel van kapcsolva – a saját partner (pssyssysfile.partner_id) az alapértelmezett
      if (this.configuration.sysParams.isBankItemSysPartnerPreload && this.configuration.sysPartnerId > 1) {
        this.store.bankDocument.bankStatementItem.partner = this.configuration.sysPartnerId;
      }
    }

    this.filter = new FilteringModel()
        .value("partner", store.bankDocument.partner)
        .value("currency", store.bankDocument.bankStatementItem.currency)
        .value("bankStatement", store.bankDocument.bankStatementItem.id)

    await this.pStore.loadCurrencies();
    await this.pStore.loadUsers();
    await this.store.loadAccountTypes();
    await this.store.loadBankAccountStatuses();
    await this.store.loadAccountSubtypes();
  },

  mounted(){
    this.store.setAccountSubtypes();

    this.getNewItemCurrencyRate(false);
    if (this.store.bankDocument.bankStatementItem.id < 2){
        this.setAccountSubType();
        this.originalAccountType = 1;
      } else {
        this.originalAccountType = this.store.bankDocument.bankStatementItem.accountType;
      }

      if (!(this.store.bankDocument.bankStatementItem.invCurrency)){
        this.store.bankDocument.bankStatementItem.invCurrency = this.defaultCurrency.value;
      }

      this.store.bankDocument.payInDeviza = this.store.bankDocument.bankStatementItem.isDev;

      this.setAmounts();
      this.isAmountChangeVisible = false;
      this.bankInSelect = undefined;
      this.bankOutSelect = undefined;
      this.bankInOutSelect = undefined;

      this.lateEdit = false;
  },

  methods: {
    async carSelected(item) {
      this.carSelect = false;

      await this.store.addCar(
          this.store.bankDocument.bankStatementItem.id,
          item
        );
      this.$emit("refreshItems");
    },

    edit(){
      if (this.isInvoiceSelect || this.isOverSelect){
        eventBus.$emit("error", "Ilyen típusú tétel nem módosítható utólag!");
        return;
      }

      this.lateEdit = true;
    },

    async generateBankOutOverSelected(items: any){
      if (items.selectedItems.some((x: any) => x.statementID == this.store.bankStatement.id)){
        eventBus.$emit("error", "Nem fizetheti vissza ugyanazon a kivonaton a túlfizetést, amiben keletkezett!");
        eventBus.$emit("bank-over-out-view:reload");
        return;
      }

      if (!this.payementGenIsProgress){
        this.payementGenIsProgress = true;

        if (!(this.store.bankDocument.bankStatementItem.currency)) this.store.bankDocument.bankStatementItem.currency = this.defaultCurrency.value;
        if (!(this.store.bankDocument.bankStatementItem.invCurrency)) this.store.bankDocument.bankStatementItem.invCurrency = this.store.bankStatement.currency;
        await this.store.saveItem(false);

        await this.store.generateBankOutOverPayments(
          Number(this.$route.params["id"]),
          this.store.bankDocument.bankStatementItem.id,
          items.selectedItems
        );
        eventBus.$emit("bank-over-out-view:reload");
        this.$emit("refreshItems");

        this.payementGenIsProgress = false;
      }
    },

    async generateBankInOverSelected(items){
      if (items.selectedItems.some((x: any) => x.statementID == this.store.bankStatement.id)){
        eventBus.$emit("error", "Nem fizetheti vissza ugyanazon a kivonaton a túlfizetést, amiben keletkezett!");
        eventBus.$emit("bank-over-in-view:reload");
        return;
      }

      if (!this.payementGenIsProgress){
        this.payementGenIsProgress = true;

        if (!(this.store.bankDocument.bankStatementItem.currency)) this.store.bankDocument.bankStatementItem.currency = this.defaultCurrency.value;
        if (!(this.store.bankDocument.bankStatementItem.invCurrency)) this.store.bankDocument.bankStatementItem.invCurrency = this.store.bankStatement.currency;
        await this.store.saveItem(false);

        await this.store.generateBankInOverPayments(
          Number(this.$route.params["id"]),
          this.store.bankDocument.bankStatementItem.id,
          items.selectedItems
        );
        eventBus.$emit("bank-over-in-view:reload");
        this.$emit("refreshItems");

        this.payementGenIsProgress = false;
      }
    },

    setAccountSubType() {
      if (this.isReverseSelection) {
        // Fordított kiválasztásnál az altípus a felhasználó választása, az automatikus előtöltés nem írhatja felül
        return;
      }

      const accType = this.store.accountTypes.find(x => x.name.toLocaleLowerCase() == 'számlakiegyenlítés');
      if (store.bankDocument.bankStatementItem.accountType == accType?.id){
        if (this.store.bankDocument.bankStatementItem.crediting){
          const subType = this.store.accountSubtypes.find(x => x.name.toLocaleLowerCase() == 'számlakiegyenlítés (vevői)');
          store.bankDocument.bankStatementItem.accountSubtype = subType?.id ?? 1;
        } else {
          const subType = this.store.accountSubtypes.find(x => x.name.toLocaleLowerCase() == 'számlakiegyenlítés (szállítói)');
          store.bankDocument.bankStatementItem.accountSubtype = subType?.id ?? 1;
        }
      }
    },

    setWrong(){
      if (!this.wrongInProgress){
        this.wrongInProgress = true;

        this.store.wrongBankDocument(this.store.bankDocument.bankStatementItem.id).then(x => {
          this.store.bankDocument.bankStatementItem.status = 4;
        }).finally(() => {
          this.$emit("refreshItems");
          this.wrongInProgress = false;
        });
      }
    },

    setPaid(){
      if (!this.emailSelection) {
        this.selectedEmails = [];
        this.store.bankDocument.invoiceItems.filter(i => i.code == "NOTO" && i.isEInvoice).forEach(i => {
              this.selectedEmails?.push({
              notoInvNo: i.invoiceID,
              k2dInvNo: i.maskedInvNo,
              emails: [],
              selected: true,
              partnerID: i.partner,
              finalPrefix: i.finalInvoicePrefix
              });
          });

        if (this.selectedEmails.length > 0){
          this.isReportSelect = false;
          this.emailSelection = true;
          return;
        }
      }

      if (!this.payInProgress){
        this.payInProgress = true;

        this.store.paidBankDocument(this.store.bankDocument.bankStatementItem.id, this.reportSelection, this.selectedEmails).then(x => {
          this.store.bankDocument.bankStatementItem.status = 3;
        }).finally(() => {
          this.$emit("refreshItems");
          this.payInProgress = false;
          this.isReportSelect = false;
          this.emailSelection = false;
          this.reportSelection = undefined;
          this.selectedEmails = undefined;
        });
      }
    },

    accountTypeChanged(value) {
      if (value == 2)//"számlakiegyenlítés"
      {
        //this.isOverpaymentWarning = true;
      }
      this.store.bankDocument.bankStatementItem.accountSubtype = 1;
      this.store.setAccountSubtypes();
      if (this.store.bankDocument.bankStatementItem.id < 2){
        this.setAccountSubType();
      }
    },

    accountSubTypeChanged(value) {
      if (!this.isReverseSelection) {
        //Nem kell
        return;
      }

      // Fordított kiválasztás: az altípus határozza meg a tétel típust (közös, type = 1 altípusnál marad a kézi választás)
      const sub = this.store.allAccountSubtypes.find(x => x.id === value);
      if (sub && sub.type > 1 && sub.type !== this.store.bankDocument.bankStatementItem.accountType) {
        this.store.bankDocument.bankStatementItem.accountType = sub.type;
        this.store.setAccountSubtypes();
      }

      // Fordított kiválasztás: az altípushoz rendelt partner tölti elő a tétel partnerét, 1 esetén (nincs hozzárendelt partner) kiüríti
      if (sub) {
        this.store.bankDocument.bankStatementItem.partner = sub.bankStatItemPartnerId > 1 ? sub.bankStatItemPartnerId : 1;
      }
    },

    bankDocumentCurrAmountChanged(amount) {
      this.store.bankDocument.bankStatementItem.currAmount = amount;

      if(amount)
      {
        if (this.bankDocument.payInDeviza && this.store.bankStatement.currency == this.defaultCurrency.value) {
          this.amount = amount * (this.store.bankDocument.bankStatementItem.exchangeRate == 0 ? 1 : this.store.bankDocument.bankStatementItem.exchangeRate);
          this.currAmount = amount;
          
          this.store.bankDocument.bankStatementItem.amount = this.amount;
          this.store.bankDocument.bankStatementItem.currAmount = this.currAmount;
          
          return;
        }

        this.store.bankDocument.bankStatementItem.amount =
          amount * (this.store.bankDocument.bankStatementItem.exchangeRate == 0 ? 1 : this.store.bankDocument.bankStatementItem.exchangeRate);
      }
      else
      {
        this.store.bankDocument.bankStatementItem.amount = 0;
        this.store.bankDocument.bankStatementItem.currAmount = 0;
      }
    },

    bankDocumentAmountChanged(amount) {
      this.store.bankDocument.bankStatementItem.amount = amount;

      if(amount)
      {
        if(this.store.bankDocument.bankStatementItem.exchangeRate && this.store.bankDocument.bankStatementItem.exchangeRate > 0)
        {
          if (this.bankDocument.payInDeviza && this.store.bankStatement.currency == this.defaultCurrency.value) {
            this.currAmount = amount / (this.store.bankDocument.bankStatementItem.exchangeRate);
            this.amount = amount;

            this.store.bankDocument.bankStatementItem.currAmount = this.currAmount;
            this.store.bankDocument.bankStatementItem.amount = this.amount;
            return;
          }

          this.store.bankDocument.bankStatementItem.currAmount =
            amount / (this.store.bankDocument.bankStatementItem.exchangeRate);
        }
        else
          this.store.bankDocument.bankStatementItem.currAmount = 0;
      }
      else
      {
        this.store.bankDocument.bankStatementItem.amount = 0;
        this.store.bankDocument.bankStatementItem.currAmount = 0;
      }
    },

    setAmounts(){
      // A tárolt értékek mindig kanonikusak: curr_amount a (deviza) tétel-pénznemben,
      // amount rendszerpénznemben (HUF). A megjelenítő mezők ezt tükrözik.
      this.currAmount = this.store.bankDocument.bankStatementItem.currAmount;
      this.amount = this.store.bankDocument.bankStatementItem.amount;
    },

    resetCurrencyAmounts() {
        this.store.bankDocument.bankStatementItem.invCurrency = this.store.bankDocument.bankAccountCurrency;
        this.store.bankDocument.bankStatementItem.currency = this.defaultCurrency.value;
        this.store.bankDocument.bankStatementItem.rateDate = this.store.bankStatement.edate;

      if (this.store.bankStatement.currency == this.defaultCurrency.value){
        this.store.bankDocument.bankStatementItem.exchangeRate = 1;
        this.store.bankDocument.bankStatementItem.currAmount = this.store.bankDocument.bankStatementItem.amount;
      } else {
        this.getNewItemCurrencyRate(true).then(_ => {
          this.bankDocumentAmountChanged(this.store.bankDocument.bankStatementItem.amount);
        });
      }
    },

    setBackToDefault() {
      this.store.bankDocument.bankStatementItem.isDev = this.store.bankDocument.payInDeviza;

      if (!this.store.bankDocument.payInDeviza) {
        this.resetCurrencyAmounts();
      } else if (this.store.bankStatement.currency != this.defaultCurrency.value){
        this.store.bankDocument.bankStatementItem.invCurrency = this.store.bankStatement.currency;
        this.store.bankDocument.bankStatementItem.currency = this.defaultCurrency.value;
      }

      if (this.sortVisible)
      {
        this.sortVisible = false;

        /*if (this.isInvoiceSelect){
          if (this.store.bankDocument.bankStatementItem.crediting){
            eventBus.$emit("bank-in-view:get-items");
            console.log('1');
          } else {
            eventBus.$emit("bank-out-view:get-items");
            console.log('2');
          }
        } else if (this.isOverSelect){
          if (this.store.bankDocument.bankStatementItem.crediting){
            eventBus.$emit("bank-over-in-view:get-items");
            console.log('3');
          } else {
            eventBus.$emit("bank-over-out-view:get-items");
            console.log('4');
          }
        }*/
      }
    },

    async setExchangeRate() {
      try {
        this.loading = true;

        if (
          this.store.bankDocument.bankStatementItem.invCurrency ===
          this.store.bankDocument.bankAccountCurrency
        ) {
          this.resetCurrencyAmounts();
          return;
        }

        const currency = this.store.bankStatement.currency == this.defaultCurrency.value ?
          this.store.bankDocument.bankStatementItem.invCurrency :
          this.store.bankStatement.currency;
        
          const result = await http
          .post<ApiResponse<{ rate: number; rateDate: Date }>>(
            `bank-statement/document/exchange-rate`, {
              currency: currency,
              rateDate: this.store.bankDocument.bankStatementItem.rateDate,
              checkForPrevious: true
            }
          )
          .then(handleApiResponse);

          this.store.bankDocument.bankStatementItem.exchangeRate = result.rate;
          this.store.bankDocument.bankStatementItem.rateDate = result.rateDate;

      } finally {
        this.loading = false;
      }
    },

    onInvoiceCurrencyChange(value) {
      // A "Számla pénzneme" választó csak HUF bankszámlánál szerkeszthető (devizásnál letiltott).
      // A kiválasztott (deviza) pénznem az inv_currency-be kerül; a currency a bankszámla
      // pénzneme (HUF) marad. Így a tétel kanonikus alakú: amount=HUF, curr_amount=deviza.
      this.store.bankDocument.bankStatementItem.invCurrency = value;
      this.setExchangeRate();
    },

    // SAKT179: a "nem egyezik az összeg" kérdés feltétele. Devizás banknál a bank
    // pénznemében hasonlítunk (ahogy a backend CreatePaymentForBankStatement is: curr_amount
    // vs. felvett + válogatott banki összeg), 2 tizedesre kerekítve. Korábban HUF-ban, egészre
    // kerekítve, a számla saját árfolyamán hasonlított, ezért EUR banknál a pontos fedezésnél
    // is mindig feljött a kérdés. HUF banknál a régi HUF-os hasonlítás marad, fillérre kerekítve.
    // itemCrediting: az összes számla válogatóban (v_bankinout) a már felvett paymentek a
    // kivonat tétel irányához képest előjelesek (VIZT351).
    isPaymentSumConfirmNeeded(selectedBankSum, hufSum, itemCrediting) {
      const round2 = (value: number) => Math.round(value * 100) / 100;
      const sign = (crediting: boolean) => itemCrediting === undefined || crediting == itemCrediting ? 1 : -1;

      if (this.isDevBank) {
        const item = this.store.bankDocument.bankStatementItem;
        // A SortingView.addedPaymentCurrSum logikája: a már felvett paymentek banki pénznemben
        const paidBankSum = this.store.bankDocument.paymentItems.reduce((pv, cv) => {
          if (cv.isExchangeComp) return pv;
          const inBank = cv.invCurrency != item.invCurrency
            ? round2(cv.paidCurrAmount * cv.exchangeRate / item.exchangeRate)
            : cv.paidCurrAmount;
          return pv + sign(cv.crediting) * inBank;
        }, 0);

        return round2(selectedBankSum + paidBankSum) != round2(item.currAmount);
      }

      const paymentSum = this.store.bankDocument.paymentItems.reduce((pv, cv) => pv + sign(cv.crediting) * Math.round(cv.paidCurrAmount * cv.exchangeRate), 0);
      return round2(hufSum + paymentSum) != round2(this.amount);
    },

    async generateBankInsSelected(items) {
      const sum = items.selectedItems.reduce((pv, cv) => pv + Math.round((cv.currToPayment * cv.exchangeRate)), 0);
      const bankSum = items.selectedItems.reduce((pv, cv) => pv + Math.abs(cv.statementTotal), 0);
      if (this.isPaymentSumConfirmNeeded(bankSum, sum) && !this.isAmountChangeVisible){
        this.isAmountChangeVisible = true;
        this.bankInSelect = items;
        return;
      }
      
      this.isAmountChangeVisible = false;

      if (this.bankInSelect && items.selectedItems.length == 0){
        items.selectedItems = this.bankInSelect.selectedItems;
      }

      if (!this.payementGenIsProgress){
        this.payementGenIsProgress = true;

        if (!(this.store.bankDocument.bankStatementItem.currency)) this.store.bankDocument.bankStatementItem.currency = this.defaultCurrency.value;
        if (!(this.store.bankDocument.bankStatementItem.invCurrency)) this.store.bankDocument.bankStatementItem.invCurrency = this.store.bankStatement.currency;
        await this.store.saveItem(false);

        await this.store.generateBankInPayments(
          Number(this.$route.params["id"]),
          this.store.bankDocument.bankStatementItem.id,
          items.selectedItems,
          items.isOverrideAmount
        );

        this.bankInSelect = undefined;

        eventBus.$emit("bank-in-view:reload");
        this.$emit("refreshItems");

        this.payementGenIsProgress = false;
      }
    },

    //Összes számla válogató (v_bankinout): a fizetési tétel generálás backend oldala
    //azonos a bankin/bankout esetén (CreatePaymentForBankStatement), ezért elég a bankin
    //végpontot hívni. VIZT351: a payment iránya a számla saját iránya (direction), az összegek
    //a kivonat tétel irányához képest előjelesek (ellentétes irányú számla csökkenti).
    async generateBankInOutsSelected(items) {
      const itemCrediting = this.store.bankDocument.bankStatementItem.crediting;
      const sum = items.selectedItems.reduce((pv, cv) => pv + (cv.isCrediting == itemCrediting ? 1 : -1) * Math.round((Math.abs(cv.currToPayment) * cv.exchangeRate)), 0);
      const bankSum = items.selectedItems.reduce((pv, cv) => pv + (cv.isCrediting == itemCrediting ? 1 : -1) * Math.abs(cv.statementTotal), 0);
      if (this.isPaymentSumConfirmNeeded(bankSum, sum, itemCrediting) && !this.isAmountChangeVisible){
        this.isAmountChangeVisible = true;
        this.bankInOutSelect = items;
        return;
      }

      this.isAmountChangeVisible = false;

      if (this.bankInOutSelect && items.selectedItems.length == 0){
        items.selectedItems = this.bankInOutSelect.selectedItems;
      }

      if (!this.payementGenIsProgress){
        this.payementGenIsProgress = true;

        if (!(this.store.bankDocument.bankStatementItem.currency)) this.store.bankDocument.bankStatementItem.currency = this.defaultCurrency.value;
        if (!(this.store.bankDocument.bankStatementItem.invCurrency)) this.store.bankDocument.bankStatementItem.invCurrency = this.store.bankStatement.currency;
        await this.store.saveItem(false);

        await this.store.generateBankInPayments(
          Number(this.$route.params["id"]),
          this.store.bankDocument.bankStatementItem.id,
          items.selectedItems,
          items.isOverrideAmount
        );

        this.bankInOutSelect = undefined;

        eventBus.$emit("bank-in-out-view:reload");
        this.$emit("refreshItems");

        this.payementGenIsProgress = false;
      }
    },

    async generateBankOutsSelected(items) {
      const sum = items.selectedItems.reduce((pv, cv) => pv + Math.round((cv.currToPayment * cv.exchangeRate)), 0);
      const bankSum = items.selectedItems.reduce((pv, cv) => pv + Math.abs(cv.statementTotal), 0);
      if (this.isPaymentSumConfirmNeeded(bankSum, sum) && !this.isAmountChangeVisible){
        this.isAmountChangeVisible = true;
        this.bankOutSelect = items;
        return;
      }

      this.isAmountChangeVisible = false;

      if (this.bankOutSelect && items.selectedItems.length == 0){
        items.selectedItems = this.bankOutSelect.selectedItems;
      }

      if (!this.payementGenIsProgress){
        this.payementGenIsProgress = true;

        if (!(this.store.bankDocument.bankStatementItem.currency)) this.store.bankDocument.bankStatementItem.currency = this.defaultCurrency.value;
        if (!(this.store.bankDocument.bankStatementItem.invCurrency)) this.store.bankDocument.bankStatementItem.invCurrency = this.store.bankStatement.currency;
        await this.store.saveItem(false);

        await this.store.generateBankOutPayments(
        Number(this.$route.params["id"]),
        this.store.bankDocument.bankStatementItem.id,
        items.selectedItems,
        items.isOverrideAmount
      );

      this.bankOutSelect = undefined;

      eventBus.$emit("bank-out-view:reload");
      this.$emit("refreshItems");
      this.payementGenIsProgress = false;
      }
    },

    cancelSort() {
      this.sortVisible = false;
    },

    sort() {
      this.sortVisible = !this.sortVisible;
    },

    cancel() {
      this.store.bankDocument = new BankDocument();
      this.$emit("hideCreate", false);
    },

    async getNewItemCurrencyRate(force = false){
      
      if (this.store.bankDocument.bankStatementItem.id > 1 && !force){
        return;
      }

      if (this.store.bankStatement.currency != this.defaultCurrency.value){
        const crediting = this.store.bankDocument.bankStatementItem.crediting;
        this.store.bankDocument.bankStatementItem.rateDate = this.store.bankStatement.edate;
        

        if (crediting){
          const currencyRate = await BankStatementApi.getCreditingRate(this.store.bankStatement.currency, this.store.bankStatement.edate);
          this.store.bankDocument.bankStatementItem.exchangeRate = currencyRate.rate;
          this.store.bankDocument.bankStatementItem.rateDate = currencyRate.rateDate;
        } else {
          const openRate = this.store.bankStatement.openRate;
          const closeRate = await BankStatementApi.getAverageRate(this.store.bankStatement.id);

          if (!closeRate || closeRate.rate == 0){
            this.store.bankDocument.bankStatementItem.exchangeRate = openRate;
          } else {
            this.store.bankDocument.bankStatementItem.exchangeRate = closeRate.rate;
            this.store.bankDocument.bankStatementItem.rateDate = closeRate.rateDate;
          }
        }

      } else {
        if (this.store.bankDocument.bankStatementItem.invCurrency == this.defaultCurrency.value){
          this.store.bankDocument.bankStatementItem.exchangeRate = 1;
          this.store.bankDocument.bankStatementItem.rateDate = this.store.bankStatement.edate;
        }
      }
    },

    async paid(){
      const accType = this.store.accountTypes.find(x => x.name.toLocaleLowerCase() == 'számlakiegyenlítés');
      if (store.bankDocument.bankStatementItem.accountType == accType?.id){
        if (this.store.bankDocument.bankStatementItem.id > 1){
        const bankDocument = this.store.bankDocuments.find(x => x.bankStatementItem.id == this.store.bankDocument.bankStatementItem.id);
        if (bankDocument && bankDocument.paymentItems.length == 0){
            this.isOverPayment = true;
        } else {
          await this.saveOnlyPaid();
        }
      } else {
        this.isOverPayment = true;
      }
      } else {
        await this.saveOnlyPaid();
      }
    },

    async generateOverPayment(){
        this.isOverPayment = false;

        if (!(this.store.bankDocument.bankStatementItem.currency)) this.store.bankDocument.bankStatementItem.currency = this.defaultCurrency.value;
        if (!(this.store.bankDocument.bankStatementItem.invCurrency)) this.store.bankDocument.bankStatementItem.invCurrency = this.store.bankStatement.currency;
        await this.store.saveItem(true);

        this.setPaid();
    },

    async saveOnlyPaid(){
        this.isOverPayment = false;
        if (this.payInProgress){
          return;
        }

        if (!(this.store.bankDocument.bankStatementItem.currency)) this.store.bankDocument.bankStatementItem.currency = this.defaultCurrency.value;
        if (!(this.store.bankDocument.bankStatementItem.invCurrency)) this.store.bankDocument.bankStatementItem.invCurrency = this.store.bankStatement.currency;
        await this.store.saveItem(false);

        if (this.store.bankDocument.invoiceItems.some(i => i.prefix == "NOTO"))
        {
          const request: any[] = [];
          this.reportSelection = [];

          this.store.bankDocument.invoiceItems
            .filter(i =>
              i.code === "NOTO" &&
              (i.finalInvoicePrefix === "GENO" || i.finalInvoicePrefix === "PARO")
            )
            .forEach(i => {
              request.push(BankStatementApi.getNotoReports(i.invoice).then(r => {
                if (r.isReport) {
                  this.reportSelection?.push({
                    notoID: i.invoice,
                    selectedReport: '',
                    reports: r.reports,
                    notoK2DInvNo: i.maskedInvNo,
                  });
                }
              }));
            });

          if (request.length > 0)
          {
            await Promise.all(request);
            if (this.reportSelection.length > 0){
              // Stimulsoft riportot kell választani → marad a jelenlegi flow (riport + email a fizetés előtt, inline küldés)
              this.isReportSelect = true;
              return;
            }
          }
        }

        // Nincs stimulsoft riport → e-számla dialógus fizetés ELŐTT, majd fizetés + kiküldés (mint a pénztárban)
        await this.preparePostPayEInvoice();
    },

    async preparePostPayEInvoice(){
      // Fizetés ELŐTT lekérjük az e-számla jelölteket (előlegbekérők, amelyekből végszámla
      // generálódik). E-számlánál az "elektronikus", egyébként a "papír alapú" az alapértelmezett.
      const candidates: Array<EmailSelection> = (await this.store.getEInvoiceCandidates(this.store.bankDocument.bankStatementItem.id))
        .filter(c => !c.isStimulSoft)
        .map(c => ({
          notoInvNo: c.noto,
          invNo: undefined,
          k2dInvNo: c.notoLabel,
          partnerID: c.partner,
          finalPrefix: c.finalPrefix,
          emails: [],
          selected: true,
          invoiceMode: c.isEInvoice ? 'electronic' : 'paper',
        } as EmailSelection));

      if (candidates.length > 0){
        // A dialógust még fizetés előtt megmutatjuk; a fizetés és a kiküldés a megerősítéskor
        // (confirmPostPayEInvoice) történik.
        this.selectedEmails = candidates;
        this.isPostPayEInvoice = true;
        this.emailSelection = true;
        return;
      }

      // Nincs e-számla jelölt → sima fizetés.
      await this.payBankDocument();
      this.$emit("refreshItems");
    },

    async payBankDocument(eInvoiceSelections: { noto: number; isEInvoice: boolean }[] = []){
      if (this.payInProgress){
        return undefined;
      }
      this.payInProgress = true;
      try {
        const result = await this.store.paidBankDocument(this.store.bankDocument.bankStatementItem.id, undefined, undefined, eInvoiceSelections);
        this.store.bankDocument.bankStatementItem.status = 3;
        return result;
      } finally {
        this.payInProgress = false;
      }
    },

    onEmailSelectionConfirm(){
      if (this.isPostPayEInvoice){
        this.confirmPostPayEInvoice();
      }
      else {
        this.setPaid();
      }
    },

    async confirmPostPayEInvoice(){
      // Elektronikus / aláírás nélküli számlánál kötelező legalább egy e-mail cím.
      const missingEmail = (this.selectedEmails ?? []).some(s => s.invoiceMode !== 'paper' && s.emails.length === 0);
      if (missingEmail) {
        eventBus.$emit("error", "Elektronikus számla esetén legalább egy e-mail címet ki kell választani!");
        return;
      }

      try {
        // A generált előlegszámla einvoice flag-jét a kiválasztott számlamód adja:
        // csak az "elektronikus" számít e-számlának.
        const eInvoiceSelections = (this.selectedEmails ?? []).map(s => ({
          noto: s.notoInvNo,
          isEInvoice: s.invoiceMode === 'electronic',
        }));

        // 1) Fizetés (a felhasználó a fizetés előtti dialógusban megerősítette).
        const result = await this.payBankDocument(eInvoiceSelections);

        // 2) A generált végszámlákat noto alapján mappeljük a begyűjtött e-mailekhez/módhoz.
        const stResults = (result as any)?.stResults ?? [];
        const items = (this.selectedEmails ?? [])
          .filter(s => s.invoiceMode !== 'paper' && s.emails.length > 0)
          .map(s => ({ s, st: stResults.find((r: any) => r.noto === s.notoInvNo) }))
          .filter(x => x.st)
          .map(({ s, st }) => ({
            prefix: st.code,
            invNo: st.invoice,
            emails: s.emails.map(e => e.email),
            isStimulSoft: false,
            reportName: "",
            isRemote: s.invoiceMode === 'remote',
            noto: s.notoInvNo,
          }));

        // 3) Kiküldés a fizetés UTÁN.
        if (items.length > 0){
          await this.store.sendBankEInvoices(items);
          eventBus.$emit("success", "Elektronikus számlák kiküldve!");
        }
      } catch (ex) {
        console.log(ex);
        eventBus.$emit("error", "Nem sikerült az elektronikus számlák kiküldése!");
      } finally {
        this.emailSelection = false;
        this.isPostPayEInvoice = false;
        this.selectedEmails = undefined;
        this.$emit("refreshItems");
      }
    },

    cancelEmailSelection(){
      const wasPostPay = this.isPostPayEInvoice;
      this.emailSelection = false;
      this.selectedEmails = undefined;
      this.isPostPayEInvoice = false;
      if (wasPostPay){
        this.$emit("refreshItems");
      }
    },

    async save() {
      if (this.store.bankDocument.bankStatementItem.accountSubtype < 2 && this.subtypeItems.length > 1){
        eventBus.$emit("error", "Meg kell adnia altípust!");
        return;
      }

      if (!this.saveInProgress){
        this.saveInProgress = true;

        if (!(this.store.bankDocument.bankStatementItem.currency)) this.store.bankDocument.bankStatementItem.currency = this.defaultCurrency.value;
        if (!(this.store.bankDocument.bankStatementItem.invCurrency)) this.store.bankDocument.bankStatementItem.invCurrency = this.store.bankStatement.currency;

        await this.store.saveItem(false, this.lateEdit);

        if (this.lateEdit) {
          // Utólagos módosításnál a backend újraszámolja a kivonat egyenlegét, ezt frissíteni kell
          await this.store.loadBankStatement(this.store.bankStatement.id);
        }

        const document = this.store.bankDocument;

        if(document.bankStatementItem.status != 2) // ha már nem módosítható
        {
          this.store.bankDocument = new BankDocument();
          //this.$emit("hideCreate", false);
          this.$emit("refreshItems");

          this.saveInProgress = false;
          return;
        }

        if(document.bankStatementItem.accountType == 2) // ha számlaválogatásos
        {
          //this.store.bankDocument = new BankDocument();
          //this.$emit("hideCreate", false);
          this.$emit("refreshItems");

          this.saveInProgress = false;
          return;
        }

        //this.store.bankDocument = new BankDocument();
        //this.$emit("hideCreate", false);
        this.$emit("refreshItems");

        this.saveInProgress = false;
        return;
      }
    },

    partnerSelected(partner: Partner) {
      this.store.bankDocument.partner = partner.name;
      this.setAccountSubType();
    },
  },

  computed: {
    isEditable(){
      // Utólagos módosítás csak HUF-os banknál és főkönyvbe még fel nem adott kivonatnál
      const accountStatus = this.store.bankStatement.accountStatus;
      const isSent = accountStatus == 4 || accountStatus == 6 || accountStatus == 9 || accountStatus == 10;

      return !this.isDevBank && this.store.bankDocument.bankStatementItem.status == 3 && !isSent;
    },

    isDevBank(){
      return this.store.bankStatement.currency != this.defaultCurrency.value;
    },

    isPayment(){
      if (this.store.bankDocument.bankStatementItem.id > 1){
        const bankDocument = this.store.bankDocuments.find(x => x.bankStatementItem.id == this.store.bankDocument.bankStatementItem.id);
        if (bankDocument && bankDocument.paymentItems.length > 0){
            return true;
        }
      }

      return false;
    },

    carsVisible() {
      const otherAccType = this.store.accountTypes.find(x => x.name.toLocaleLowerCase() == 'egyéb')?.id ?? 1;
      return /*store.bankDocument.bankStatementItem.accountType == otherAccType &&*/ this.store.bankDocument.bankStatementItem.id > 1;
    },

    accountTypes(){
      if (this.store.bankStatement.isReopen || this.lateEdit){
        const invoiceAccType = this.store.accountTypes.find(x => x.name.toLocaleLowerCase() == 'számlakiegyenlítés')?.id ?? 1;
        const overAccType = this.store.accountTypes.find(x => x.name.toLocaleLowerCase() == 'túlfizetés rendezés')?.id ?? 1;

        const accountTypes = this.store.accountTypes.filter(x => (x.id != invoiceAccType || this.store.bankDocument.bankStatementItem.accountType == invoiceAccType) && (x.id != overAccType || this.store.bankDocument.bankStatementItem.accountType == overAccType));

        if (this.store.bankDocument.bankStatementItem.crediting){
          //Jóváírás

          return accountTypes.filter(x => x.isIn);
        }
        else{
          //Terhelés

          return accountTypes.filter(x => x.isOut);
        } 
      } else {

        if (this.store.bankDocument.bankStatementItem.crediting){
          //Jóváírás

          return this.store.accountTypes.filter(x => x.isIn);
        }
        else{
          //Terhelés

          return this.store.accountTypes.filter(x => x.isOut);
        }        
      }
    },

    isReverseSelection(){
      return this.configuration.sysParams.isBankItemReverseSelection;
    },

    subtypeItems(){
      if (!this.isReverseSelection) {
        // Régi működés: a kiválasztott típus szerint szűrt lista
        return this.store.accountSubtypes;
      }

      // Fordított kiválasztás: az összes altípus listázása
      // (reopen/kései módosításnál a számlakiegyenlítés / túlfizetés rendezés altípusai továbbra sem választhatók,
      // ahogy a típusválasztóban sem)
      if (this.store.bankStatement.isReopen || this.lateEdit) {
        const invoiceAccType = this.store.accountTypes.find(x => x.name.toLocaleLowerCase() == 'számlakiegyenlítés')?.id ?? 1;
        const overAccType = this.store.accountTypes.find(x => x.name.toLocaleLowerCase() == 'túlfizetés rendezés')?.id ?? 1;
        const currentAccType = this.store.bankDocument.bankStatementItem.accountType;
        const current = this.store.bankDocument.bankStatementItem.accountSubtype;

        return this.store.allAccountSubtypes.filter(s =>
          ((s.type != invoiceAccType || currentAccType == invoiceAccType) &&
           (s.type != overAccType || currentAccType == overAccType)) || s.id === current);
      }

      return this.store.allAccountSubtypes;
    },

    isReopen(){
      let accType = this.store.accountTypes.find(x => x.name.toLocaleLowerCase() == 'számlakiegyenlítés');
      const isInvoice = this.originalAccountType == accType?.id;

      accType = this.store.accountTypes.find(x => x.name.toLocaleLowerCase() == 'túlfizetés rendezés');
      const isOver = this.originalAccountType == accType?.id;

      return this.store.bankStatement.isReopen && !isInvoice && !isOver;
    },

    isInvoiceSelect(){
      const accType = this.store.accountTypes.find(x => x.name.toLocaleLowerCase() == 'számlakiegyenlítés');
      return store.bankDocument.bankStatementItem.accountType == accType?.id;
    },

    isOverSelect(){
      const accType = this.store.accountTypes.find(x => x.name.toLocaleLowerCase() == 'túlfizetés rendezés');
      return store.bankDocument.bankStatementItem.accountType == accType?.id;
    },

    isSortingVisible() {
      return (this.isInvoiceSelect || this.isOverSelect) && this.store.bankDocument.bankStatementItem.id > 1;
    },

    isDisabled() {
      if (this.store.bankDocument.bankStatementItem.status == 3 || this.store.bankDocument.bankStatementItem.status == 4) 
      {
        return true;
      }
      return false;
    },

    bankDocument() { 
      return this.store.bankDocument;
    },

    crediting(){
      return this.store.bankDocument.bankStatementItem.crediting;
    },

    defaultCurrency(){
      return configuration.sysParams.defaultCurrency;
    },

    currencyRate(){
      return this.store.bankDocument.bankStatementItem.exchangeRate;
    },

    accountType(){
      return this.store.bankDocument.bankStatementItem.accountType;
    }
  },

  watch: {
    accountType: function(){
      this.setAccountSubType();
    },

    crediting: function(){
      this.getNewItemCurrencyRate(true);
      this.setAccountSubType();
    },

    bankDocument(){
      if (this.store.bankDocument.bankStatementItem.id <= 1) {
      this.store.bankDocument.user = auth.userName;
      this.store.bankDocument.bankStatementItem.user = auth.userID;
      this.store.bankDocument.bankStatementItem.currency = this.defaultCurrency.value;
      this.store.bankDocument.bankStatementItem.invCurrency = this.store.bankStatement.currency;
      this.store.bankDocument.bankStatementItem.extNo = Number.parseInt(this.$route.params.id);
      this.store.bankDocument.bankAccountCurrency = this.store.bankStatement.currency;

      // Új tételnél – ha a rendszerparaméter fel van kapcsolva – a saját partner (pssyssysfile.partner_id) az alapértelmezett
      if (this.configuration.sysParams.isBankItemSysPartnerPreload && this.configuration.sysPartnerId > 1) {
        this.store.bankDocument.bankStatementItem.partner = this.configuration.sysPartnerId;
      }
    } else {
      this.store.bankDocument.payInDeviza = this.store.bankDocument.bankStatementItem.isDev;
    }

      this.getNewItemCurrencyRate(false);
      this.originalAccountType = this.store.bankDocument.bankStatementItem.accountType;
      this.allInvoiceSelector = false;
      this.filter.value("bankStatement", store.bankDocument.bankStatementItem.id);

      this.store.setAccountSubtypes();

      if (this.sortVisible){
        this.sortVisible = false;
      }

      this.setAmounts();
      this.lateEdit = false;
    },

    currencyRate() {
      const accType = this.store.accountTypes.find(x => x.name.toLocaleLowerCase() == 'árf. ker. különbözet');

      if (this.store.bankDocument.bankStatementItem.accountType != (accType?.id ?? 0)){
        this.bankDocumentCurrAmountChanged(this.currAmount);
      }
    },

    isInvoiceSelect() {
      if (this.store.bankDocument.bankStatementItem.id < 2) {
        //this.setExchangeRate();
      }
    }, 
  },
});
